import { ThemeEvents } from '@theme/events';

class StockMessage extends HTMLElement {
  connectedCallback() {
    this.closest('.shopify-section, dialog')?.addEventListener(ThemeEvents.variantUpdate, this.onVariantUpdate);
  }

  disconnectedCallback() {
    this.closest('.shopify-section, dialog')?.removeEventListener(ThemeEvents.variantUpdate, this.onVariantUpdate);
  }

  onVariantUpdate = (e) => {
    const fresh = e.detail.data.html?.querySelector('stock-message');
    if (fresh) {
      this.outerHTML = fresh.outerHTML;
      return;
    }

    this.style.display = 'none';
  };
}

if (!customElements.get('stock-message')) {
  customElements.define('stock-message', StockMessage);
}
